import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { User} from 'src/app/models/dashboard-common.model';

@Component({
  selector: 'app-specialist-details',
  templateUrl: './specialist-details.component.html',
  styleUrls: ['./specialist-details.component.less']
})
export class SpecialistDetailsComponent implements OnInit {
  @Input() user:User;
  @Output() update: EventEmitter<boolean> = new EventEmitter();
  pocImageBroken: boolean = false;
   shortTitle:string;
   constructor() { }

  ngOnInit(): void {
  }
  ngOnChanges() {
  }
  getInitials(user: User): string {
    
    return `${user.firstName ? user.firstName.charAt(0) : ''}${user.lastName ? user.lastName.charAt(0) : ''}`;
  }
  imageBroken(value: boolean) {
    this.pocImageBroken = value;
  }
   
  
  delete(){
   this.update.emit(true);
  }
}
